import React, {Component} from 'react';
import { observer , inject } from 'mobx-react';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';


import { getInitiation, getMonthlyDues, getAnnualFee, getAmountDueToday, getSaleDuration, isCommitVerbage, bestValue } from './ProductInfoItems.js';

class MultipleProduct extends Component {
    index = 0



    handleChange = (e) => {
        this.index = Number(e.target.value);
        //should be using state and not forcing rerender
        this.forceUpdate()
    }

    constructor(props){
        super(props);
        this.membershipDetailsPressed = this.membershipDetailsPressed.bind(this)
        this.selectProductPressed = this.selectProductPressed.bind(this)
    }

    membershipDetailsPressed(e){
        //product ID's and club ID's
        this.props.DGRStore.setProductID(e.target.name)

        this.props.DGRModalStore.setSection('productDetails')
        this.props.DGRModalStore.setCloseVisible()
        this.props.DGRModalStore.openModal()
    }
    selectProductPressed(e){
        const {selectFunction} = this.props
        selectFunction(e)
    }
    render(){
        const products = this.props.products
        const theme = createMuiTheme({
          palette: {
            primary: { main: '#D52B1E' }, // Purple and green play nicely together.
            secondary: { main: '#11cb5f' }, // This is just green.A700 as hex.
          },
        });

        return (
                <div className="productCard">
                    <div className="productCardFlex">
                        <div className="productLeft">
                            <div className="title">
                                <span className="titleName">{ products[this.index].name }</span>
                                { bestValue( products[this.index] ) }
                            </div>
                            <div className="productInfo">
                              <p className="subinfo">
                                {isCommitVerbage(products[this.index])}
                                &nbsp;
                                <button
                                className="memberDetails"
                                name={ products[this.index].popup_id }
                                onClick={this.membershipDetailsPressed}>
                                    See Membership Details
                                </button>
                              </p>
                            </div>
                            <FormControl component="fieldset" className="">
                            <div className="radiooptions">
                            <MuiThemeProvider theme={theme}>

                              <RadioGroup
                                name="type"
                                value={String(this.index)}
                                onChange={this.handleChange}
                              >
                                    <FormControlLabel value="0" control={<Radio color='primary' />} label={products[0].subline} />
                                    <FormControlLabel value="1" control={<Radio color='primary' />} label={products[1].subline} />

                            </RadioGroup>
                            </MuiThemeProvider>
                            </div>

                            </FormControl>

                            {getSaleDuration(products[this.index])}
                        </div>

                        <div className="productRight">
                            {getMonthlyDues(products[this.index])}
                            {getInitiation(products[this.index])}
                            {getAnnualFee(products[this.index])}
                            {getAmountDueToday(products[this.index])}
                            <button
                                onClick= {this.selectProductPressed}
                                name={products[this.index].id}
                                value={products[this.index].id}
                                className="bigButton">Select
                            </button>
                        </div>
                    </div>
                </div>
        )
    }
}

MultipleProduct = inject('DGRStore','DGRModalStore')(observer(MultipleProduct ))
export default MultipleProduct



// WEBPACK FOOTER //
// ./src/components/DGR/MembershipOptions/MultipleProduct.js